module.exports = __webpack_public_path__ + "img/instrument-promotion.ea13d6f4.png";